import React, { Component } from 'react';
import Link from 'gatsby-link';

export default class footer extends Component {
  render() {
    return (
      <div className="row footer px-0 px-md-4 mt-4 py-2">
        <div className="col-12">
          <hr />
        </div>
        <div className="col-md-6">
          <p>Copyright {new Date().getFullYear()} TUSK, Inc.</p>
          <p>All Rights Reserved</p>
          <p><Link to="/privacy-policy">Privacy Policy</Link> • <Link to="/terms-of-use">Terms and Conditions</Link></p>
        </div>
        <div className="col-md-6 text-md-right">
      
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.js